// Compact human summary of selected delivery days for section-title subtext,
// e.g. "Mon, Tue, Fri", "Every day", or "None". Mirrors
// LeadOrdersHelper#delivery_days_summary (server-side initial render) — keep
// the two in sync.
const DAY_LABELS = {
  MON: "Mon",
  TUE: "Tue",
  WED: "Wed",
  THU: "Thu",
  FRI: "Fri",
  SAT: "Sat",
  SUN: "Sun",
};

const DAY_ORDER = Object.keys(DAY_LABELS);

export function formatDeliveryDaysSummary(days) {
  const selected = new Set((days || []).map((day) => String(day).toUpperCase()));
  const ordered = DAY_ORDER.filter((day) => selected.has(day));
  if (ordered.length === 0) return "None";
  if (ordered.length === DAY_ORDER.length) return "Every day";
  return ordered.map((day) => DAY_LABELS[day]).join(", ");
}
